export default {
  mounted() {
    let {title} = this.$options;
    if (title) {
      title = typeof title === 'function' ? title.call(this) : title
      this.TitleModule_setPageTitle(title);
    }
  },
  methods: {
    TitleModule_setPageTitle(title) {
      const default_title = 'CUONA MANAGER';
      document.title = title ? `${title} - ${default_title}` : default_title;
    },
  }
}
